import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { FavoritesProvider } from "@/hooks/useFavorites";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ToolPage from "@/pages/ToolPage";
import About from "@/pages/About";

function App() {
  return (
    <div className="App">
      <FavoritesProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tool/:slug" element={<ToolPage />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </Layout>
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </FavoritesProvider>
    </div>
  );
}

export default App;
